import moment from 'moment';
import axios from 'axios';

import api from './api';
import { urls } from '../config';
import { ToastMessage } from '../context/ToastContext';
import { handleExceptionMessage } from '../util/handleExceptionAxios';
import { message } from '../util/handleMessages';
import { generateFaturasPdf } from '../componets/jsPdfPrinter';
import { gerarRecibosPdf } from '../componets/recibosJspdf';

export interface IDataReport {
    nameReport: string;
    params: any;
    pathImage?: string;
    setLoading?: (loading: boolean) => void;
    addToast(message: Omit<ToastMessage, 'id'>): void;
}

function base64ToArrayBuffer(base64: any) {
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

export const downloadReport = async ({
    nameReport,
    params,
    pathImage,
    setLoading,
    addToast,
}: IDataReport) => {
    try {
        const responseDataToReport = await api.post(
            `reports?nameReport=${nameReport}`,
            {
                nameReport,
                query: { ...params, jasperReport: false }, // Colocar para true se usar o jasperReport novamente
            },
        );
        const dataResponse = responseDataToReport.data;

        // Chamada no backend de relatórios
        const baseURLApiReport =
            process.env.REACT_APP_ENVIROMENT === 'local'
                ? urls.apiReport.local
                : urls.apiReport.prod;

        const token = localStorage.getItem('@GESSIS:token');
        let typeArchive = 'pdf';
        if (params.type) {
            typeArchive = params.type;
        }
        let doc = null;
        switch (nameReport) {
            case 'recibo':
                if (pathImage) {
                    dataResponse.data = { ...dataResponse.data, pathImage };
                }
                doc = gerarRecibosPdf(dataResponse);
                doc.save(
                    `${nameReport}_${moment().format(
                        'YYYYMMDDHmmss',
                    )}.${typeArchive}`,
                );
                break;
            case 'faturamento_user':
                doc = generateFaturasPdf(dataResponse);
                doc.save(
                    `${nameReport}_${moment().format(
                        'YYYYMMDDHmmss',
                    )}.${typeArchive}`,
                );
                break;
            case 'faturamento':
                doc = generateFaturasPdf(dataResponse, {
                    includeSaldo: true,
                });
                doc.save(
                    `${nameReport}_${moment().format(
                        'YYYYMMDDHmmss',
                    )}.${typeArchive}`,
                );
                break;
            default:
                params.type = 'pdf';
                break;
        }

        // const response = await axios.post(
        //     `${baseURLApiReport}/reports`,
        //     {
        //         nameReport: `advogados_${nameReport}`,
        //         dataset: dataResponse.dataset,
        //         data: dataResponse.data,
        //     },
        //     {
        //         responseType: 'arraybuffer',
        //         params,
        //         headers: {
        //             Authorization: 'Bearer ' + token,
        //         },
        //     },
        // );

        // const blob = new Blob([response.data], {
        //     type: `application/${typeArchive}`,
        // });
        // const link = document.createElement('a');
        // link.href = window.URL.createObjectURL(blob);
        // link.download = `${nameReport}_${moment().format(
        //     'YYYYMMDDHmmss',
        // )}.${typeArchive}`;
        // link.click();
    } catch (error) {
        console.error(error);
        setLoading && setLoading(false);
        const { messageResponse: messagesResponse, typeFeedback } = handleExceptionMessage(error);
        addToast({
            type: typeFeedback,
            title: message.error.downloadPdf,
            description: messagesResponse,
        });
    }
};
